import React from 'react';

const AgreementsInformationOath = () => (
  <p>
    You confirm and affirm
    that all information, representations, warranties, affirmations,
    acknowledgements and agreements that you have provided or made in this
    application are voluntarily and knowingly given and made, are true, complete
    and accurate, and not misleading in any respect,&nbsp;
    <em>
      and you will promptly
      notify us in writing if any of the information or any representation you have
      provided materially changes or ceases to be true, complete and accurate
    </em>.
  </p>
);

export default AgreementsInformationOath;
